import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import ComplyColors, { fontFamily } from "../Constants/constants";

const AltVendorIDModal = ({ open, onClose, onContinue }) => {
  const [altVendorID1, setAltVendorID1] = useState("");
  const [altVendorID2, setAltVendorID2] = useState("");
  const [altVendorID3, setAltVendorID3] = useState("");

  const dropdownOptions = ["ID", "Deloitte ID", "Investor ID"];

  // Reset values when modal opens
  useEffect(() => {
    if (open) {
      setAltVendorID1("");
      setAltVendorID2("");
      setAltVendorID3("");
    }
  }, [open]);

  // Get available options for each dropdown (exclude already selected values)
  const getAvailableOptions = (currentValue) => {
    const selectedValues = [altVendorID1, altVendorID2, altVendorID3].filter(
      (val) => val && val !== currentValue
    );
    return dropdownOptions.filter((option) => !selectedValues.includes(option));
  };

  const handleContinue = () => {
    const selectedValues = {
      AltVendorID1: altVendorID1,
      AltVendorID2: altVendorID2,
      AltVendorID3: altVendorID3,
    };
    onContinue(selectedValues);
  };

  const handleClose = () => {
    // Reset values when closing
    setAltVendorID1("");
    setAltVendorID2("");
    setAltVendorID3("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "10px",
          padding: "10px",
        },
      }}
    >
      <DialogTitle
        style={{
          fontFamily: fontFamily,
          fontSize: "20px",
          fontWeight: "600",
          color: ComplyColors.primaryColor,
          borderBottom: `2px solid ${ComplyColors.primaryColor}`,
          paddingBottom: "10px",
        }}
      >
        Select Alternative Vendor IDs
      </DialogTitle>

      <DialogContent style={{ paddingTop: "20px" }}>
        <Typography
          style={{
            fontFamily: fontFamily,
            fontSize: "14px",
            color: "#666",
            marginBottom: "20px",
          }}
        >
          Please select values for the alternative vendor ID fields:
        </Typography>

        <Box style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* AltVendorID1 Dropdown */}
          <FormControl fullWidth>
            <InputLabel
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                color: "#666",
              }}
            >
              AltVendorID1
            </InputLabel>
            <Select
              value={altVendorID1}
              onChange={(e) => setAltVendorID1(e.target.value)}
              label="AltVendorID1"
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                backgroundColor: "#f5f9fc",
                borderRadius: "5px",
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              {getAvailableOptions(altVendorID1).map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  style={{
                    fontFamily: fontFamily,
                    fontSize: "14px",
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* AltVendorID2 Dropdown */}
          <FormControl fullWidth>
            <InputLabel
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                color: "#666",
              }}
            >
              AltVendorID2
            </InputLabel>
            <Select
              value={altVendorID2}
              onChange={(e) => setAltVendorID2(e.target.value)}
              label="AltVendorID2"
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                backgroundColor: "#f5f9fc",
                borderRadius: "5px",
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              {getAvailableOptions(altVendorID2).map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  style={{
                    fontFamily: fontFamily,
                    fontSize: "14px",
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* AltVendorID3 Dropdown */}
          <FormControl fullWidth>
            <InputLabel
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                color: "#666",
              }}
            >
              AltVendorID3
            </InputLabel>
            <Select
              value={altVendorID3}
              onChange={(e) => setAltVendorID3(e.target.value)}
              label="AltVendorID3"
              style={{
                fontFamily: fontFamily,
                fontSize: "14px",
                backgroundColor: "#f5f9fc",
                borderRadius: "5px",
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              {getAvailableOptions(altVendorID3).map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  style={{
                    fontFamily: fontFamily,
                    fontSize: "14px",
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions
        style={{
          padding: "20px",
          justifyContent: "space-between",
        }}
      >
        <Button onClick={handleClose} variant="contained" className="cancel-btn-filled">
          Cancel
        </Button>
        <Button onClick={handleContinue} variant="contained" className="review-btn-filled">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AltVendorIDModal;
